import { BareActionContext } from 'vuex-typex'
import { ConvoState } from '@/store/convo/state'
import { RootState } from '@/store'
import convoUtils from '@/store/convo/actions/convo-utils'
import processConvos from '@/store/convo/actions/process-convos'
import { IConvo } from '@/model/convo'
import convoStore from '@/store/convo/convo-store';

export default async function fetchUpdateConvo(context: BareActionContext<ConvoState, RootState>, id: number)
{
  convoUtils.convoService.getById(id.toString()).then((convo: IConvo) => {
    convoStore.commitUpdateConvo({ convo: convo })
  })

  return
}
